export default __webpack_public_path__ + "static/media/icon-orders-redeemed.01587919.svg";